module.exports = __webpack_public_path__ + "img/fhblank.6bcfebbf.png";